import {
  NgModule
} from '@angular/core';
import {
  AccountDetailComponent
} from './account-detail.component';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../../shared/common';
import {
  LoadingIndicatorModule
} from '../../shared/layout/components/loading-indicator';
import {BreadcrumbModule} from '../../shared/layout/components/breadcrumb';
import {GridModule} from '@progress/kendo-angular-grid';
import {ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from '@progress/kendo-angular-dialog';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import {FlexLayoutModule} from '@angular/flex-layout';
import {CardDialogComponent} from './components/card-dialog/card-dialog.component';
import {ConfirmDialogComponent} from '../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {AgmCoreModule, GoogleMapsAPIWrapper} from '@agm/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {AccountDialogComponent} from './components/account-dialog/account-dialog.component';
import {DurationPipe} from '../../shared/duration/duration.pipe';
import {AppModule} from '../../app.module';
import {FloatingLabelModule} from '@progress/kendo-angular-label';
import {CommissionDialogComponent} from './components/commissions/commission-dialog.component';
import {PaymentSourceComponent} from '../../source/payment-source.component';
import {ShopifyIntegrationDialogComponent} from './components/integrations/shopify/shopify-integration-dialog.component';

@NgModule({
  declarations: [
    AccountDetailComponent,
    CardDialogComponent,
    CommissionDialogComponent,
    DurationPipe,
    ShopifyIntegrationDialogComponent
  ],
  imports: [
    ButtonsModule,
    DateInputsModule,
    GridModule,
    DropDownsModule,
    InputsModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    SharedCommonModule,
    ReactiveFormsModule,
    DialogModule,
    FloatingLabelModule,
    MatExpansionModule,
    MatDialogModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatGridListModule,
    FlexLayoutModule,
    AgmCoreModule
  ],
  exports: [
  ],
  providers: [
    GoogleMapsAPIWrapper,
    DurationPipe
  ],
  entryComponents: [
    CardDialogComponent,
    ConfirmDialogComponent,
    AccountDialogComponent,
    CommissionDialogComponent,
    PaymentSourceComponent,
    ShopifyIntegrationDialogComponent
  ],
})
export class AccountDetailModule {
}
